module.exports = __webpack_public_path__ + "static/media/blog-2.8e6cd66a.jpg";